import { render, staticRenderFns } from "./ApprovalPage.vue?vue&type=template&id=330a2e78"
import script from "./ApprovalPage.vue?vue&type=script&lang=js"
export * from "./ApprovalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports